import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const NFTCardPlaceholder = () => {
  return (
    <>
      <div className="card__item four">
        <div className="card_body space-y-10">
          <Skeleton height={20} width="80%" />
          <div className="card_head">
            <Skeleton
              height={"22rem"}
              width="100%"
              style={{ paddingTop: "-1rem" }}
            />
          </div>
          <div className="card_footer d-block space-y-10">
            <Skeleton height={15} width="50%" />
          </div>
        </div>
      </div>
    </>
  );
};

export default NFTCardPlaceholder;
